/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface ChallengeBase
 */
export interface ChallengeBase {
    /**
     * 
     * @type {string}
     * @memberof ChallengeBase
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof ChallengeBase
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof ChallengeBase
     */
    authentication_method: FactorMethod;
}



/**
 * Check if a given object implements the ChallengeBase interface.
 */
export function instanceOfChallengeBase(value: object): value is ChallengeBase {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function ChallengeBaseFromJSON(json: any): ChallengeBase {
    return ChallengeBaseFromJSONTyped(json, false);
}

export function ChallengeBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeBase {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function ChallengeBaseToJSON(json: any): ChallengeBase {
    return ChallengeBaseToJSONTyped(json, false);
}

export function ChallengeBaseToJSONTyped(value?: ChallengeBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
    };
}

